<div class="card detail">
  <div class="card-body">
    <div class="title d-flex justify-content-between">
      <div class="d-flex flex-column justify-content-between">
        <h3 class="card-title">{{ 'Projects' | translate }}</h3>
        <p class="text-muted" *ngIf="currLoc && !currLoc.id">{{'All facilities' | translate}}</p>
        <p *ngIf="currLoc && currLoc.id && !currLoc.parent"><a routerLink="/projects">{{'All facilities' | translate}}</a> / <span class="text-muted">{{currLoc.name}}</span></p>
        <p *ngIf="currLoc && currLoc.id && currLoc.parent"><a [routerLink]="['/projects', currLoc.parent.id, 'details', 'summary']">{{currLoc.parent.name}}</a> / <span class="text-muted">{{currLoc.name}}</span></p>
      </div>
      <div *ngIf="permissions && permissions['create:any.location'] && (currLoc && !currLoc.id)" class="action-btn">
        <a class="btn btn-sm btn-circle btn-outline-primary" [routerLink]="['projects', 'create']">
          <i class="icon-create"></i>
        </a>
      </div>
    </div>
    <ul class="list-group mt-2">
      <li class="list-group-item" *ngIf="(projects | async)?.length === 0">
        <div class="card inner-shadow">
          <div class="card-body">{{ 'No Project' | translate }}</div>
        </div>
      </li>
      <li class="list-group-item">
        <div *ngFor="let project of projects | async; trackById">
          <app-card-project [data]="project"></app-card-project>
        </div>
      </li>
    </ul>
  </div>
</div>